import { AppEnvSchema } from './schema'

export type { AppEnv } from './schema'
export { AppEnvSchema } from './schema'

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        __ENV__: unknown
    }
}

const result = AppEnvSchema.safeParse(import.meta.env.DEV ? import.meta.env : window.__ENV__)

if (!result.success) {
    throw new Error(
        `Invalid runtime config. Ensure the runtime config script is loaded before the app bundle. ${result.error.message}`
    )
}

export const env = result.data
